import { create } from 'zustand';
import { createShiftRotation } from '@libs/api/shifts';
import { ShiftRotation, ShiftRotationUpdate } from '@libs/models/shifts/rotation';

type State = {
  loading: boolean;
  drawerOpen: boolean;
  rotationId: string;
  drawerMode: 'add' | 'edit';
  initiated: boolean;
  data: ShiftRotation | null;
  load: (id: string) => void;
  openShiftRotationDrawer: (id?: string) => void;
  closeShiftRotationDrawer: () => void;
  createRotation: (rotation: ShiftRotationUpdate) => Promise<string[]>;
};

export const useShiftRotationAddEditStore = create<State>()((set, get) => ({
  loading: false,
  drawerOpen: false,
  drawerMode: 'add',
  initiated: false,
  rotationId: '',
  data: null,
  load: async (id) => {
    set({ loading: true });
    try {
      // const resp = await fetchShiftsList(page, perPage, org);
      set({
        loading: false,
        // data: resp.data,
      });
    } finally {
      set({ loading: false, initiated: true });
    }
  },
  openShiftRotationDrawer: (id) => {
    set({ drawerMode: id ? 'edit' : 'add', rotationId: id, drawerOpen: true });
  },
  closeShiftRotationDrawer: () => {
    set({ drawerOpen: false });
  },
  createRotation: async (rotation) => {
    const results = await createShiftRotation(rotation);
    return results.map((res) => {
      return res.id;
    });
  },
}));
